import { Component, h, Listen, Prop } from '@stencil/core';
import type { FacetValue } from '../../../../../api/model/response/facets/Facets';
import { FILTERS_ID_SEPARATOR } from '../../../../../constants/filterConstants';
import type {FilterNode} from '../../../facets-build-wrapper/filter-node';
import type {FacetsShowChildrenType} from '../../../../strategies/types/facets-config-strategy-data.type';
import {FacetsV2Service} from '../../../../../utils/services/facets/facets-v2.service';

@Component({
  tag: 'svs-chips-view',
  shadow: false,
  scoped: true,
  styleUrl: 'svs-chips-view.scss'
})
export class ChipsViewComponent {
    @Prop() readonly clearHandler: Function;
    @Prop() readonly filtersChips: Array<FacetValue|FilterNode>;
    @Prop() readonly dividerFacets: string[] = [];
    @Prop() readonly hiddenFacets: string[] = [];
    @Prop() readonly showChildren: FacetsShowChildrenType = 'allways';
    @Prop() readonly facetsV2Service: FacetsV2Service;

    render() {
        return <div class={{'chips-view': this.filtersChips?.length > 0 }}>
          {this.filtersChips.filter(filterChip => {
              const splitedUniqueId = filterChip.uniqueId.split(FILTERS_ID_SEPARATOR);
              const facetId = splitedUniqueId[0];
              let isNotDividerFacetAndFirstLevelFilters = true;

              if(this.showChildren === 'allways' || this.showChildren === 'whenParentSelected') {
                isNotDividerFacetAndFirstLevelFilters = !(this.dividerFacets.includes(facetId) && splitedUniqueId.length === 2);
              }

              if(this.showChildren === 'onlyLastChilds') {
                if(!this.facetsV2Service.notLastUniqueIds[filterChip.uniqueId]) {
                  return false;
                }
                return !this.facetsV2Service.notLastUniqueIds[filterChip.uniqueId].includes(filterChip.uniqueId);
              }

              return !this.hiddenFacets.includes(facetId) && isNotDividerFacetAndFirstLevelFilters;
          }).map(filterChip => {
              const disabled = filterChip.chipDisabled;
              return (
                <qds-chip text={filterChip.displayName} disabled={disabled}
                  onClick={disabled ? (e)=> e.stopPropagation() : ()=> this.clearHandler(filterChip)}
                  type={disabled ? undefined : 'closable'}
                ></qds-chip>);
          })}
        </div>;
    }
};
